import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { FileText, Download, Loader2 } from 'lucide-react';

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (format: 'pdf' | 'csv' | 'excel') => Promise<void>;
}

export function ExportModal({ isOpen, onClose, onExport }: ExportModalProps) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format: 'pdf' | 'csv' | 'excel') => {
    setExporting(true);
    try {
      await onExport(format);
      onClose();
    } finally {
      setExporting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Export Analytics">
      <div className="space-y-4">
        <p className="text-sm text-gray-500">
          Choose a format to export your analytics data
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <button
            onClick={() => handleExport('pdf')}
            disabled={exporting}
            className="flex flex-col items-center rounded-lg border border-gray-200 p-4 hover:bg-gray-50"
          >
            <FileText className="h-8 w-8 text-gray-400" />
            <span className="mt-2 font-medium">PDF Report</span>
          </button>

          <button
            onClick={() => handleExport('csv')}
            disabled={exporting}
            className="flex flex-col items-center rounded-lg border border-gray-200 p-4 hover:bg-gray-50"
          >
            <FileText className="h-8 w-8 text-gray-400" />
            <span className="mt-2 font-medium">CSV Export</span>
          </button>

          <button
            onClick={() => handleExport('excel')}
            disabled={exporting}
            className="flex flex-col items-center rounded-lg border border-gray-200 p-4 hover:bg-gray-50"
          >
            <FileText className="h-8 w-8 text-gray-400" />
            <span className="mt-2 font-medium">Excel Export</span>
          </button>
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            disabled={exporting}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            {exporting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Exporting...
              </>
            ) : (
              'Cancel'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}